import { Container, Grid, Box, Typography } from '@mui/material'
import ListaOpcoes from '../../../../utils/listaOpcoes'
import HeaderSession from '../../../../utils/headerSession'
import SearchSolicitacaoImportacao from './searchSolicitacaoImportacao'

export default function Importacao() {
    return (
        <Container style={{ minHeight: '70vh' }}>
            <Box sx={{ display: { md: 'none' } }}>
                <HeaderSession title='IMPORTAÇÃO & EXPORTAÇÃO ' />
            </Box>

            <Grid container>
                <Grid margin={1} xs={12} md={5.7} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40vh' }}>
                    <img src="/icones/Import_export.svg" alt="" width={'50%'} />
                </Grid>

                <Grid m={1} xs={12} md={5.7} item >
                    <Box width={'100%'} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <HeaderSession title='IMPORTAÇÃO & EXPORTAÇÃO' />
                    </Box>

                    <Typography variant='subtitle1' fontSize={22} align="center" m={2} color={"secondary"}>
                        SOLICITAÇÃO DE AUTORIZAÇÃO PARA IMPORTAÇÃO DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE
                    </Typography>

                    <ListaOpcoes nomeOpcao='Medicamentos' link='/inspeccao-regulatoria/solicitacao/importacao/Medicamentos' />
                    <ListaOpcoes nomeOpcao='Suplemento Alimentar' link='/inspeccao-regulatoria/solicitacao/importacao/Suplemento-Alimentar' />
                    <ListaOpcoes nomeOpcao='Equipamento' link='/inspeccao-regulatoria/solicitacao/importacao/Equipamento' />
                    <ListaOpcoes nomeOpcao='Reagente' link='/inspeccao-regulatoria/solicitacao/importacao/Reagentes-TDRs' />
                    <ListaOpcoes nomeOpcao='Cosmético' link='/inspeccao-regulatoria/solicitacao/importacao/Cosmetico' />
                    <ListaOpcoes nomeOpcao='Vacina' link='/inspeccao-regulatoria/solicitacao/importacao/Vacina' />
                    <ListaOpcoes nomeOpcao='TDRS' link='/inspeccao-regulatoria/solicitacao/importacao/TDRS' />
                    <ListaOpcoes nomeOpcao='Outros' link='/inspeccao-regulatoria/solicitacao/importacao/Outros' />

                    {/* <ListaOpcoes nomeOpcao='Solicitar declaração de desalfandegamento' link='/utente/solicitacao/numero-de-declaracao' /> */}

                    <br />
                    <br />

                    <Typography variant='subtitle2' fontSize={15} align="center" m={1} color={"secondary"}>
                        Consultar solicitações de importação
                    </Typography>
                    <SearchSolicitacaoImportacao />
                    {/* <SelecteTipoCertificado />
                    <ListaOpcoes nomeOpcao='Cadastrar importador' link='#' /> */}
                </Grid>

            </Grid>
            <br />
        </Container>
    )
}
